import React from 'react';

/**
 * InputButtonProps now supports className for custom styling from parent components.
 */
interface InputButtonProps {
  icon: React.ReactNode;
  label?: string;
  onClick?: () => void;
  type?: 'button' | 'submit';
  disabled?: boolean;
  variant?: 'primary' | 'secondary';
  isActive?: boolean;
  className?: string;
  dataTestId?: string;
}

export const InputButton: React.FC<InputButtonProps> = ({
  icon,
  label,
  dataTestId,
  onClick,
  type = 'button',
  disabled = false,
  variant = 'secondary',
  isActive = false,
  className = '',
}) => {
  if (!label) {
    return (
      <button
        type={type}
        onClick={onClick}
        disabled={disabled}
        data-testid={dataTestId}
        className={`flex h-8 w-8 items-center justify-center rounded-full transition-colors ${
          variant === 'primary'
            ? 'bg-[#FF732E] text-white hover:bg-[#E65A1F] disabled:bg-gray-300'
            : isActive
              ? 'bg-[#FF732E]/10 text-[#FF732E] hover:bg-[#FF732E]/20'
              : 'text-gray-500 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700'
        } ${className}`}
      >
        {icon}
      </button>
    );
  }

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      data-testid={dataTestId}
      className={`inline-flex items-center gap-2 rounded-xl border px-3 py-1 text-sm transition-colors ${
        isActive
          ? 'border-[#FF732E] bg-[#FF732E]/10 text-[#FF732E] hover:bg-[#FF732E]/20'
          : 'border-gray-200 bg-gray-100 text-gray-700 hover:bg-gray-200 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-600'
      } ${className}`}
    >
      {icon}
      <span
        style={{
          maxWidth: '120px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          display: 'inline-block',
          verticalAlign: 'middle',
        }}
      >
        {label}
      </span>
    </button>
  );
};
